import { render, staticRenderFns } from "./CardKPILarge.vue?vue&type=template&id=c2f9b200&scoped=true"
import script from "./CardKPILarge.vue?vue&type=script&lang=js"
export * from "./CardKPILarge.vue?vue&type=script&lang=js"
import style0 from "./CardKPILarge.vue?vue&type=style&index=0&id=c2f9b200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f9b200",
  null
  
)

export default component.exports